import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export function AuthProvider({ children }){
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("user")); }
    catch { return null; }
  });

  useEffect(() => {
    if (user) localStorage.setItem("user", JSON.stringify(user));
    else localStorage.removeItem("user");
  }, [user]);

  function loginSuccess(payload){
    // payload { token, user }
    localStorage.setItem("token", payload.token);
    setUser(payload.user);
  }

  function logout(){
    localStorage.removeItem("token");
    setUser(null);
  }

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, loginSuccess, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
